module.exports = __webpack_public_path__ + "img/arrows-down.5b22dcf9.svg";